/**
 * US state / territory names → USPS 2-letter codes.
 * Mapbox returns region names ("Texas"); stops and USPS validation need codes ("TX").
 */
const STATE_CODES: Record<string, string> = {
  alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA',
  colorado: 'CO', connecticut: 'CT', delaware: 'DE', 'district of columbia': 'DC',
  florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN',
  iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD',
  massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS', missouri: 'MO',
  montana: 'MT', nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
  'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND',
  ohio: 'OH', oklahoma: 'OK', oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI',
  'south carolina': 'SC', 'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT',
  vermont: 'VT', virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI',
  wyoming: 'WY', 'puerto rico': 'PR', guam: 'GU', 'u.s. virgin islands': 'VI',
  'american samoa': 'AS', 'northern mariana islands': 'MP'
}; // prettier-ignore

const VALID_CODES = new Set(Object.values(STATE_CODES));

/** "Texas" → "TX", "tx" → "TX", "US-TX" → "TX". Unknown input → "". */
export function toStateCode(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  if (!raw) return '';
  const code = raw.toUpperCase().replace(/^US-/, '');
  if (VALID_CODES.has(code)) return code;
  return STATE_CODES[raw.toLowerCase()] ?? '';
}
